import React from "react";
import fluidsImg from "../../assets/images/CATEGTuneup.PNG";
import detailImg from "../../assets/images/CATEGDetail.PNG";
import partsImg from "../../assets/images/PWCPARTS.PNG";
import accsImg from "../../assets/images/ACCSPWC.PNG";
import spraysImg from "../../assets/images/SPRAYSPWC.PNG";
import { useNavigate } from "react-router-dom";

export default function FeaturedCategories() {
    const navigate = useNavigate();
const categories = [
  {
    name: "Parts",
    slug: "used-oem",
    image: partsImg
  },

  {
    name: "Accessories",
    slug: "accessories",
    image: accsImg
  },

  {
    name: "Marine Detailing",
    slug: "marine-detailing",
    image: detailImg
  },

  {
    name: "Lubricants & Sprays",
    slug: "lubricants",
    image: spraysImg
  },

  {
    name: "Fluids & Maintenance",
    slug: "fluids",
    image: fluidsImg
  }
];



  const styles = {
   section: {
  background: "transparent",
  padding: "50px 0"
},

    title: {
      fontSize: "30px",
      fontWeight: 600,
      color: "#111",
      marginBottom: "30px"
    },

    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "40px",
      flexWrap: "wrap"
    },

    item: {
      textAlign: "center",
      flex: "1",
      minWidth: "160px"
    },

   circle: {
  width: "150px",
  height: "150px",
  borderRadius: "50%",
  background: "#EEEEEE",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",

  // 💎 Premium depth shadow
  boxShadow: "0 30px 60px rgba(0, 0, 0, 0.15), 0 12px 25px rgba(0, 0, 0, 0.08)",

  transition: "all 0.25s ease"
},

    image: {
      maxWidth: "80%",
      maxHeight: "80%",
      objectFit: "contain"
    },

    label: {
      marginTop: "14px",
      fontSize: "15px",
      fontWeight: 500,
      color: "#222"
    }
  };

  return (
    <div style={styles.section}>
      <div style={styles.title}>Featured categories</div>

      <div style={styles.row}>
        {categories.map((cat, i) => (
       <div
  key={i}
  style={styles.item}
  onClick={() =>
navigate(`/category/${cat.slug}`)
  }
  onMouseEnter={(e) => {
    const circle = e.currentTarget.querySelector(".circle");

    circle.style.transform = "translateY(-8px) scale(1.03)";
    circle.style.boxShadow =
      "0 45px 90px rgba(0,0,0,0.18), 0 20px 40px rgba(0,0,0,0.12)";
  }}
  onMouseLeave={(e) => {
    const circle = e.currentTarget.querySelector(".circle");

    circle.style.transform = "translateY(0px) scale(1)";
    circle.style.boxShadow =
      "0 30px 60px rgba(0, 0, 0, 0.15), 0 12px 25px rgba(0, 0, 0, 0.08)";
  }}
>
        <div className="circle" style={styles.circle}>
              <img src={cat.image} style={styles.image} />
            </div>
            <div style={styles.label}>{cat.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}